import axios from "axios";
import firebase from "../services/firebase";
import { StatusCodes } from "http-status-codes";

const baseURL = process.env.REACT_APP_API_HOST;

const AxiosInstance = () =>
  axios.create({
    baseURL,
    timeout: 600000,
    headers: {
      "Content-Type": "application/json",
    },
  });

const axiosInstance = AxiosInstance();
axiosInstance.interceptors.request.use(async (config) => {
  const user = firebase.currentUser();
  const token = user && (await user.getIdToken());
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});
axiosInstance.interceptors.response.use(
  async (response) => response,
  async (error) => {
    const { response } = error;
    if (response?.status === StatusCodes.FORBIDDEN) {
      window.location.href = "/admin";
    }

    return error;
  }
);

export default axiosInstance;
